
import { types, actions } from './requests'
export const GETSTDARTICLE_TYPES = {
    ...types('GETSTDARTICLE'),
}
export const GETSTDARTICLE_ACTIONS = {
    ...actions('GETSTDARTICLE'),
}